import angular from 'angular';
import NgAd from 'cars-ng-ad';

import directive from './partnerMarketplace.directive';

export default angular.module('app.shared.partnerMarketplace', [
    NgAd
])

.directive('carsPartnerMarketplace', directive)

.name;
